import sidePanel from 'side-panel-menu-thing'
import BigPicture from 'bigpicture'
import sal from 'sal.js'
import Calendar from '../components/page-calendar.svelte'
import WeatherApp from '../components/dashboard-weather.svelte'

const { $ } = window
const $body = $(document.body)

export default {
	init() {
		// JavaScript to be fired on all pages
		const mobileMenu = new sidePanel({
			target: $body[0],
			props: {
				target: $body[0],
				content: document.getElementById('menu'),
				fixed: true,
				width: 320,
			},
		})

		$('#toggle_nav').on('click', mobileMenu.show)

		// $(document).on(
		// 	'click',
		// 	'.menu-section .menu-item-has-children > a',
		// 	function (e) {
		// 		e.preventDefault()
		// 		let $el = $(this)
		// 		$el.parent().toggleClass('show-subnav')
		// 	}
		// )

		$(document).on(
			'click',
			'#menu-mobile-menu li.menu-item-has-children > a',
			function (e) {
				e.preventDefault()
				$(this).parent().toggleClass('show-children')
				// $(this).parent().find('.sub-menu').slideToggle()
			}
		)
		sal({
			threshold: 0.01,
			rootMargin: '-25px 9px',
		})
		const $weatherWrap = $('#weather-wrap')
		if ($weatherWrap.length) {
			new WeatherApp({
				target: document.getElementById('weather-wrap'),
			})
		}
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		let $article = $('article.main-content')

		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})

		const $calendarPage = $('.page-template-calendar')

		if ($calendarPage.length) {
			new Calendar({
				target: document.getElementById('calendar-page'),
				props: $('#calendar-page').data(),
			})
		}

		// article enlarge images
		if ($article.length) {
			$article
				.find(
					'.wp-block-image a[href*=".jpg"], .wp-block-image a[href*=".jpeg"]'
				)
				.on('click', function (e) {
					const $this = $(this)
					const $imgEls = $this.find('img')
					e.preventDefault()
					BigPicture({
						el: $imgEls.length ? $imgEls[0] : this,
						imgSrc: this.href,
					})
				})
		}

		let $blocksGallery = $('.blocks-gallery-item > figure > a')
		if ($blocksGallery.length) {
			let $caption = $('.blocks-gallery-item__caption')
			if ($caption) {
				$caption.each(function () {
					$(this).siblings('a')[0].setAttribute('data-caption', $(this).text())
				})
			}

			$blocksGallery.each(function (index, el) {
				el.setAttribute('data-bp', el.href)
			})

			$blocksGallery.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
					gallery: '.wp-block-gallery',
					loop: true,
				})
			})
		}

		let $wpBlockImg = $('.wp-block-image')
		if ($wpBlockImg.length) {
			$wpBlockImg.on('click', function (e) {
				let $img_children = $(this).children()
				if ($img_children.is('figure')) {
					//don't use bp
				} else {
					const $this = $(this)
					const $imgEls = $this.find('img')
					e.preventDefault()
					BigPicture({
						el: $imgEls.length ? $imgEls[0] : this,
						imgSrc: this.href,
					})
				}
			})
		}

		let $blockImageSingle = $('.cib-image-single')
		if ($blockImageSingle) {
			$('.cib-image-single ').on('click', function () {
				BigPicture({
					el: this,
				})
			})
		}

		// let $singleImg = $('.single-image')

		pageTransitions()
		login()

		//search
		const $navSearch = $('#main-search')
		if ($navSearch.length) {
			$('#search-icon').on('click', function () {
				$navSearch.submit()
			})
		}
	},
}

function pageTransitions() {
	const $html = $('html')
	const $mainContent = $('#main_content')

	$(document).ready(function () {
		$mainContent.addClass('fadeIn')
		$mainContent.removeClass('fadeOut')
	})

	$(window).on('unload', function () {
		$mainContent.removeClass('fadeIn')
		$mainContent.addClass('fadeOut')
	})

	$html.on('mousedown', function () {
		$html.addClass('using-mouse')
	})

	$html.on('keydown', function () {
		$html.removeClass('using-mouse')
	})

	$(window).on('popstate', function () {
		$mainContent.addClass('fadeOut')
	})

	$(document).on('turbolinks:click', function () {
		$mainContent.addClass('fadeOut')
	})
	$(document).on('turbolinks:load', function () {
		$mainContent.addClass('fadeIn')
	})
	document.addEventListener('turbolinks:before-render', function () {
		const $home = $('.page-template-dashboard')
		if (!$home.length) {
			$(document).on(
				'click',
				'#menu-mobile-menu li.menu-item-has-children > a',
				function (e) {
					e.preventDefault()
					$(this).parent().toggleClass('show-children')
					// $(this).parent().find('.sub-menu').slideToggle()
				}
			)
		}
	})

	// if (document.documentElement.hasAttribute('data-turbolinks-preview')) {
	// 	console.log('cached-preview')
	// }

	// Turbolinks.setProgressBarDelay(100)
}

function login() {
	jQuery(document).ready(function ($) {
		// Perform AJAX login on form submit

		if (localStorage.chkbx && localStorage.chkbx != '') {
			//chceck if box was checked in local storage
			$('#remember_me').attr('checked', 'checked')
			$('#username').val(localStorage.usrname)
			$('#password').val(localStorage.pass)
		} else {
			$('#remember_me').removeAttr('checked')
			$('#username').val('')
			$('#password').val('')
		}

		$('#remember_me').on('click', function () {
			//if checked update local storage values
			if ($('#remember_me').is(':checked')) {
				// save username and password
				localStorage.usrname = $('#username').val()
				localStorage.pass = $('#password').val()
				localStorage.chkbx = $('#remember_me').val()
			} else {
				localStorage.usrname = ''
				localStorage.pass = ''
				localStorage.chkbx = ''
			}
		})

		if ($('#remember_me').is(':checked')) {
			//update fields while box is checked
			$('#username').on('change', function () {
				localStorage.usrname = $('#username').val()
			})
			$('#password').on('change', function () {
				localStorage.pass = $('#password').val()
			})
		}

		$('#remember_wrap').click(function () {
			//click parent wrap and check checkbox
			$(this).find(':checkbox').click()
			return false
		})

		$(':checkbox').click(function (e) {
			//check checkbox on click
			e.stopPropagation()
			// var val = $(this).val()
		})

		$('form#login').on('submit', function (e) {
			$('form#login p.status').show().text(ajax_login_object.loadingmessage)
			$.ajax({
				type: 'POST',
				dataType: 'json',
				url: ajax_login_object.ajaxurl,
				data: {
					action: 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
					username: $('form#login #username').val(),
					password: $('form#login #password').val(),
					security: $('form#login #security').val(),
				},
				success: function (data) {
					$('form#login p.status').text(data.message)
					if (data.loggedin == true) {
						document.location.href = ajax_login_object.redirecturl
					}
				},
			})
			e.preventDefault()
		})
	})
}
